import React, { useEffect } from 'react'
import styles from '../ArticleComponents/Common.module.css'
import styles1 from './GetVaccinated.module.css'
import ArticleCoverAndHeader from '../ArticleComponents/ArticleCoverAndHeader'
import Row from '../ArticleComponents/Row';

function GetVaccinated() {

    useEffect(() => {
        window.scroll({
          top: 0, 
          left: 0, 
          behavior: 'smooth'
        });
      })

      const rows = {
        listItem: [
          "Log on to www.cowin.gov.in.",
          "Enter your mobile number.",
          "Get an OTP to create your account.",
          "Where should I register for the vaccination",
          "Enter the OTP and click on the 'Verify' button",
          "You will be directed to the registration of the vaccination' page. On this page, there will be an option to choose one photo ID proof.",
          "Fill in your name, age, gender and upload an identity document.",
          "Click on the 'Register' button.",
          "Once the registration is completed; the system will show the 'Account Details'.",
          "A citizen can further add three more people linked with this mobile number by clicking on the 'Add More' button.",
          "There will be a button indicating 'Schedule appointment'. Now click on it.",
          "Search a vaccination center of choice by state, district, block and pin code.",
          "Date and availability will also be displayed.",
          "Click on the 'book' button.",
          "On successful completion of booking, you will receive a message. That confirmation details will have to be shown at the vaccination centre.",
          "Once confirmed. the confirmation page with ‘ Appointment Successful ‘ message will be displayed.",
        ]
      }

      const rows2 = {
        heading:"Steps to Register for COVID -19  vaccination through Aarogya Setu",
        listItem: [
          "On the Aarogya Setu app homepage, go to the 'CoWIN' tab.",
          "Under the CoWIN icon, you can see four options Vaccine Information, Vaccination, Vaccination Certificate, Vaccination Dashboard.",
          "Tap on the 'Vaccination' tab and then select the 'Register Now' option.",
          "Enter your mobile number and then click on 'proceed to verify'.",
          "Enter the OTP and again select 'proceed to verify'.",
          "Once the number verification is done, you will have to upload a photo ID card.",
          "You also need to fill in other details such as age, gender, year of birth.",
          "You can register a maximum of 4 beneficiaries through the Aarogya Setu app.",
          "You can also check for vaccination sites by state, district, block and pin code. The date and availability will be displayed. Select the 'book' option.",
          "Once registered successfully, you will receive an SMS with the appointment details.",

        ]
      }

      const rows3 = {
          listItem:[
            "as a severe or persistent headache or blurred vision",
            "shortness of breath, chest pain, leg swelling or persistent abdominal pain",
            "unusual skin bruising and/or pinpoint round spots beyond the site of injection.",
  
          ]
      }

    return (
        <ArticleCoverAndHeader readTime={6} title="Why and how to Get Vaccinated" author="Priyanka Porwal" authorLink="https://www.instagram.com/priyankaporwal_/" previousGuide="/donate-plasma" nextGuide="/allAboutMasks">
        <div className={styles.introPara}>
        <p>
          With the surge in different coronavirus mutations and the
          ever-expanding list of COVID-19 symptoms, it has become all the more
          important to stay <span className={styles.highlight}>vigilant</span>{" "}
          and <span className={styles.highlight}> aware </span>of not only the
          severe but mild and unusual symptoms of{" "}
          <span className={styles.highlight}>SARs-COV-2</span>. The people
          afflicted with covid-19 have a wide range of symptoms these days
          depending on the varied range age groups as well as the type of the
          mutant exposed to. Most infected people will develop mild to moderate
          illness and recover without hospitalization.
        </p>
      </div>


      <h2 className={styles.sliderHeader}>
      Vaccines available in India
      </h2>

      <div className={styles.introPara}>
        <p>
        Multiple COVID-19 vaccines that are available in the market, including the Covishield, Covaxin, and Sputnik V vaccines that have been approved for usage in India, currently consist of two doses. 
        </p>
      </div>

      <h2 className={styles.sliderHeader}>
      WHY WE NEED TWO DOSES?
      </h2>

      <div className={styles.introPara}>
        <p>
        The first, known as the "prime dose", prepares the human immune system to build antibodies. However, these antibodies aren't long-lasting, and they gradually wane with time. This is where the second dose, referred to as the "booster dose”, comes in. It boosts the immune system’s production of a large number of antibodies, while also stimulating the memory cells, so that the body remembers this infection and continues to create antibodies against it for a long period.
In simpler terms one dose enables a relatively weaker immune response from the body. Therefore, it requires the extra second dose, which teaches the immune system to produce stronger and longer-lasting responses.

        </p>
      </div>


      <h2 className={styles.sliderHeader}>
      Effecctiveness of the vaccine
      </h2>

      <div className={styles.introPara}>
        <p>
        Whilst trials have shown several COVID-19 vaccines to have high levels of efficacy, like all other vaccines, COVID-19 vaccines will not be 100% effective. The COVID-19 vaccines produce protection against the disease, as a result of developing an immune response to the SARS-Cov-2 virus. This is particularly important to protect people at increased risk for severe illness from COVID-19, such as healthcare providers, older or elderly adults, and people with other medical conditions.
        </p>
      </div>

      <h2 className={styles.sliderHeader}>
      How To Register Yourself For COVID-19 Vaccine?
      </h2>

      <div className={styles.introPara}>
        <p>
        The general public will have to self-register themselves on the CoWIN website/app. They will have to upload a government photo identity or do an AADHAAR authentication. The authentication can happen via biometrics, OTP (one time password) or demographic. Once the registration is done, a date and time will be allocated for vaccination. There will be no on the spot registration and only pre-registered beneficiaries will be allowed to proceed for the vaccination.
        </p>
      </div>

      <h2 className={styles.sliderHeader}>
      Steps to Register for COVID-19 Vaccination through the COWIN portal
      </h2>

      <Row row={rows}/>

      <Row row={rows2}/>

      <h2 className={styles.sliderHeader}>
      Side effects of vaccine
      </h2>

    

      <div className={styles.introPara}>
        <p>
        People who have received COVID-19 vaccines should be aware of the common side effects, which include fever, sore muscles, tiredness and headache. These usually start within 24 hours of vaccination and last for 1-2 days. These side effects are expected and are not of concern unless severe or persistent.
Consumers should seek immediate medical attention if, a few days after vaccination, they develop symptoms such as:

        </p>
      </div>

      

      <img
        className={styles1.articleFirstImage}
        src="https://www.mohfw.gov.in/covid_vaccination/vaccination/dist/images/vaccine-infographic-desktop.jpg"
        alt="first_landscape_img"
      />

      <Row row={rows3}/>
      <h2 className={styles.sliderHeader}>
      Helpful tips
      </h2>

      <div className={styles.introPara}>
        <p>
        Talk to your doctor about taking over-the-counter medicine, such as ibuprofen, acetaminophen, aspirin, or antihistamines, for any pain and discomfort you may experience after getting vaccinated. You can take these medications to relieve post-vaccination side effects if you have no other medical reasons that prevent you from taking these medications normally.<br/>
        Vaccination is the only weapon we have in the war against Covid. If we ever hope to emerge victorious, it is imperative that each and every one of us gets vaccinated, thus making ourselves immune to the effects of this deadly virus.

        </p>
      </div>


        </ArticleCoverAndHeader>
    )
}

export default GetVaccinated
